import { inject } from '@angular/core';
import { ResolveFn } from '@angular/router';
import { collectRouteParams } from '@kinet-open-network/client/shared/util';
import { DocumentsStore } from './+state/documents.store';
import { DOCUMENTS_CONFIG } from './documents.provider';

export const documentsResolver: ResolveFn<void> = async (route) => {
  const config = inject(DOCUMENTS_CONFIG);
  const store = inject(DocumentsStore);
  const params = collectRouteParams(route);

  const idRouteParam = config.idRouteParam || 'id';
  const parentId = config.getIdFromRoute
    ? config.getIdFromRoute(route)
    : params[idRouteParam];

  if (!parentId) {
    throw new Error(
      `No parent ID found in route params under ${idRouteParam}! Make sure to provide correct route param or provide 'getIdFromRoute' function in the documents configuration.`,
    );
  }

  await store.queryByParent(config.parentType, parentId);
};
